/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import fetchIntercept from 'fetch-intercept';
import {
  getAuthToken, shouldSkip401Handling,
} from 'utils/app.utils';
import logOut from 'utils/logout.utils';
import { INTERCEPTOR_IGNORE_FILE_EXT, AUTH_ACCESS_TOKEN_API } from 'constants/AppConstants';

/**
 * Fetch Interceptor - intercepts all service call and attaches authorization header
 */
const Interceptor = () => {
  let signOut = true;
  const requestHeadersMap = new Map();
  /**
   * register an interceptor
   */
  const register = () => fetchIntercept.register({
    /**
     * called before the HTTP request
     * @param {String} url - service url
     * @param {Object} config - HTTP request params
     */
    request(url, config) {
      const isEVDomain = /\.evinternal\.com|\.evinternal\.net|\.eagleview\.com/.test(url);
      const isLamdaDomain = /lambda-url\.us-east-2\.on\.aws/.test(url);
      const isAwsDomain = /execute-api\.us-east-2\.amazonaws\.com/.test(url);
      if (typeof url === 'string' && !INTERCEPTOR_IGNORE_FILE_EXT.includes(url.split('.').pop()) && (isEVDomain || isLamdaDomain || isAwsDomain)) {
        if (typeof config !== 'object') {
          config = {};
        }
        let { headers, skipAuthHeader, skip401Handling } = config;
        if (!(headers instanceof Headers)) {
          headers = new Headers(headers);
          config.headers = headers;
        }
        if (!headers.has('Authorization') && !skipAuthHeader) {
          headers.append('Authorization', `Bearer ${getAuthToken()}`);
        }
        if (url === AUTH_ACCESS_TOKEN_API || skip401Handling) {
          const customHeaders = new Headers(headers);
          if (skip401Handling) {
            customHeaders.append('skip401Handling', 'true');
          }
          requestHeadersMap.set(url, customHeaders);
        }
      }
      return [url, config];
    },

    /**
     * Called when an error occured during another 'request' interceptor call
     * @param {Onject} error
     */
    requestError(error) {
      return Promise.reject(error);
    },

    /**
     * called after the HTTP request, to process HTTP response
     * @param {Object} response
     */
    response(response) {
      const { status, url } = response;
      // ignore 401 handling of signing out user for custom token fetch for secondary user
      if (status === 401 && !shouldSkip401Handling(url, requestHeadersMap)) {
        if (signOut) {
          signOut = false;
          logOut();
        }
      }
      return response;
    },

    /**
     * called if error occurs with fetch api
     * @param {Object} error
     */
    responseError(error) {
      return Promise.reject(error);
    },
  });
  return {
    register,
    fetchIntercept,
  };
};

export default Interceptor;
